import React from 'react'
import Select from 'react-select-plus'
import cx from 'classnames'
import { List } from 'immutable'
import { Input } from '@driftt/tide-core-legacy'
import InlineSVG from 'svg-inline-react'

import checkSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/check.svg'
import redXSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/redx.svg'

import {
  AudienceDisplay,
  AudienceIcons,
  AudienceType,
  ConditionCategory,
  ConditionCategoryToDisplay,
  ConditionTypes,
  OperatorToDisplay,
  ConditionTypesByCategory,
} from 'app/modules/playbook/constants'

import PlaybookModal from '../PlaybookModal'
import SegmentSelect from '../SegmentSelect'
import EmailPlaybookSelect from '../EmailPlaybookSelect'

import { ClearbitRevealTargetingPreview } from 'components/ClearbitRevealPreview'

import './style.styl'

const Category = ({ onClick, category, selected }) => (
  <div className={cx('playbook-condition-modal-category', { selected })} onClick={onClick}>
    {ConditionCategoryToDisplay[category]}
  </div>
)

const Upgrade = () => (<ClearbitRevealTargetingPreview/>)


const mapToOptions = (values) => !!values ? values.map(value => {
  return { label: value, value }
}) : []

const ConditionModal = ({
                          condition: { field, value, operator },
                          onFieldChange,
                          onValueChange,
                          onOperatorChange,
                          onCloseClick,
                          onCategoryClick,
                          selectedCategory,
                          hasSegmentSelect,
                          onSegmentNext,
                          onSegmentChange,
                          hasMarketingSequences,
                          onTestUrlChange,
                          testUrl,
                          testUrlIsValid,
                          externalData,
                          selectedCategoryOptions,
                          showEnrichmentUpgrade
                        }) => {
  const selectedConditionType =
    selectedCategory === ConditionCategory.EMAIL_PLAYBOOK
      ? ConditionTypes.get('email_playbook')
      : ConditionTypes.get(field)


  this.renderExtraContent = () => {
    if (selectedConditionType.category === ConditionCategory.URL) {

      return <div className="url-help-section">
        <div>
          <h3>How does Drift define &quot;{selectedConditionType.displayName}&quot;?</h3>
          <p>{selectedConditionType.description}</p>
        </div>
        <div>
          <h3>Example (from your input)</h3>
          <div className="playbook-condition-helptext">
            {selectedConditionType.showPreview(value)}
          </div>
        </div>
        <h3>Does your URL match?</h3>
        <p className="playbook-condition-test-url-instructions">
          Paste a URL here to see if it will match the condition above.
        </p>
        <div className="playbook-condition-test-url">
          <Input
            placeholder={'https://www.google.com/my-url'}
            value={testUrl}
            className="playbook-condition-test-url-input"
            onChange={onTestUrlChange}
          />
          {!!testUrl && <InlineSVG src={testUrlIsValid ? checkSrc : redXSrc}/>}
        </div>
      </div>
    } else if (selectedConditionType.category === ConditionCategory.ENRICHMENT && showEnrichmentUpgrade) {
      return <div className="url-help-section">
        <Upgrade/>
      </div>

    }
  }
  return (
    <PlaybookModal
      onCloseClick={onCloseClick}
      title="Targeting"
      contentClassName="playbook-condition-modal drift-form"
      headerClassName="playbook-condition-modal-header"
      description="Edit Condition"
    >
      <nav className="playbook-condition-modal-nav">
        <strong>Pick Condition Type:</strong>
        {ConditionTypesByCategory.filter((conditions, category) => {
          return category !== ConditionCategory.CLEARBIT || ACCESS.hasGates('premium_enterprise')
        })
          .filter((conditions, category) => {
            return category !== ConditionCategory.SEGMENT || hasSegmentSelect
          })
          .filter(
            (conditions, category) => category !== ConditionCategory.EMAIL_PLAYBOOK || hasMarketingSequences
          )
          .map((conditions, category) => (
            <Category
              key={category}
              category={category}
              onClick={onCategoryClick(category)}
              selected={category === selectedConditionType.category}
            />
          ))
          .toArray()}
      </nav>
      {selectedConditionType.category !== ConditionCategory.SEGMENT && (
        <div className="playbook-condition-modal-content">
          <strong>Edit Condition:</strong>
          {selectedConditionType.category === ConditionCategory.EMAIL_PLAYBOOK && (
            <div>
              <div className="playbook-condition-modal-email-select-description">
                The visitor came to my site from a link in the email playbook:
              </div>
              <EmailPlaybookSelect/>
            </div>
          )}
          {selectedConditionType.category !== ConditionCategory.EMAIL_PLAYBOOK && (
            <div>
              <div className="playbook-condition-modal-inputs">
                <Select
                  className="playbook-condition-modal-input"
                  clearable={false}
                  options={selectedCategoryOptions}
                  value={{
                    label: selectedConditionType.displayName,
                    value: field,
                  }}
                  onChange={onFieldChange}
                />
                <Select
                  className="playbook-condition-modal-input targeting-condition"
                  clearable={false}
                  options={selectedConditionType.operators.map(operator => ({
                    value: operator,
                    label: OperatorToDisplay[operator],
                  }))}
                  value={{ value: operator, label: OperatorToDisplay[operator] }}
                  onChange={onOperatorChange}
                />
                {!!selectedConditionType.externalOptionsProp &&
                <selectedConditionType.Component
                  className="playbook-condition-modal-input"
                  placeholder={selectedConditionType.placeholder}
                  value={value}
                  onChange={onValueChange}
                  options={mapToOptions(externalData[selectedConditionType.externalOptionsProp])}
                />
                }
                {!selectedConditionType.externalOptionsProp &&
                <selectedConditionType.Component
                  className="playbook-condition-modal-input"
                  placeholder={selectedConditionType.placeholder}
                  value={value}
                  onChange={onValueChange}
                />
                }
              </div>
              <div className="targeting-condition-extra-content">
                {this.renderExtraContent()}
              </div>
            </div>
          )}
        </div>
      )}
      {selectedConditionType.category === ConditionCategory.SEGMENT && (
        <div className="playbook-condition-modal-content segment-select-modal-content">
          <SegmentSelect
            onNext={onSegmentNext}
            value={value.toJS()}
            onChange={onSegmentChange}
            extraOptions={List(
              Object.keys(AudienceIcons).map(key => {
                return { id: AudienceType[key], name: AudienceDisplay[key] }
              })
            )}
            showCancel={false}
          />
        </div>
      )}
    </PlaybookModal>
  )
}

export default ConditionModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ConditionModal/component.js